import Axios, {AxiosRequestConfig, AxiosResponse, AxiosInstance, AxiosError} from 'axios';
import qs                                                                    from 'qs';

import {Broadcast}   from '@/core/service/broadcast.service';

export default class AxiosModelService {
  private axios: AxiosInstance;
  private broadcast: Broadcast = new Broadcast();
  private idKey = '${ID}';
  private TOKEN_LIST: { method: string; url: string; }[] = [
    {method: 'get', url: `/tokens/auths`},
    {method: 'get', url: `/tokens/valids`},
    {method: 'get', url: `/accounts/codes`},
    {method: 'get', url: `/accounts/codes/join-code/${this.idKey}`}
  ];

  constructor(baseURL: string) {
    const timeout = 1000 * 60;
    this.axios = Axios.create({
      baseURL,
      timeout,
      paramsSerializer: (params) => qs.stringify(params, {encoding: false, allowDots: true}),
    });

    this.axios.interceptors.request.use(
      (config: AxiosRequestConfig) => {
        this.broadcast.onSpinner(true);
        return config;
      },
      (error: AxiosError) => {
        this.broadcast.onError();
        return Promise.reject(error);
      }
    );

    this.axios.interceptors.response.use(
      (response: AxiosResponse) => {
        this.broadcast.onSpinner(false);
        return response;
      },
      (error: AxiosError) => {
        this.broadcast.onError();
        return Promise.reject(error);
      }
    );
  }

  get(url: string, options?: AxiosRequestConfig): Promise<AxiosResponse> {
    return this.axios.get(url, options);
  }

  delete(url: string, options?: AxiosRequestConfig): Promise<AxiosResponse> {
    return this.axios.delete(url, options);
  }

  post(url: string, params?: any, options?: AxiosRequestConfig): Promise<AxiosResponse> {
    return this.axios.post(url, params, options);
  }

  put(url: string, params?: any, options?: AxiosRequestConfig): Promise<AxiosResponse> {
    return this.axios.put(url, params, options);
  }

  patch(url: string, params?: any, options?: AxiosRequestConfig): Promise<AxiosResponse> {
    return this.axios.patch(url, params, options);
  }

  private isToken(config: AxiosRequestConfig): boolean {
    let returnValue: boolean = false;

    this.TOKEN_LIST.forEach((checkSpinners: { method: string; url: string; }) => {
      if (checkSpinners.method === config.method && this.isUrlEqual(config, checkSpinners.url)) {
        returnValue = true;
      }
    });

    return returnValue;
  }

  private isUrlEqual(config: AxiosRequestConfig, url: string): boolean {
    let returnValue: boolean = true;

    if (!!config.url) {
      const configUrlSplit = config.url.split('/');
      const urlSplit = url.split('/');

      if (configUrlSplit.length === urlSplit.length) {
        urlSplit.forEach((split: string, index: number) => {
          if (split !== configUrlSplit[index]) {
            if (split !== this.idKey) {
              returnValue = false;
            }
          }
        });
      } else {
        returnValue = false;
      }
    }

    return returnValue;
  }
}
